import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../components/layout";
import Section from '../components/Section/Section';
import Gallery from '../components/Gallery/Gallery';
import ContactSection from '../components/ContactSection/ContactSection';
import SEO from "../components/seo";

import galleryImg01 from '../images/gallery/gallery_01.jpg';
import galleryImg01Thumb from '../images/gallery/gallery_01-thumb.jpg';
import galleryImg02 from '../images/gallery/gallery_02.jpg';
import galleryImg02Thumb from '../images/gallery/gallery_02-thumb.jpg';
import galleryImg03 from '../images/gallery/gallery_03.jpg';
import galleryImg03Thumb from '../images/gallery/gallery_03-thumb.jpg';
import galleryImg04 from '../images/gallery/gallery_04.jpg';
import galleryImg04Thumb from '../images/gallery/gallery_04-thumb.jpg';
import galleryImg05 from '../images/gallery/gallery_05.jpg';
import galleryImg05Thumb from '../images/gallery/gallery_05-thumb.jpg';
import galleryImg06 from '../images/gallery/gallery_06.jpg';
import galleryImg06Thumb from '../images/gallery/gallery_06-thumb.jpg';
import galleryImg07 from '../images/gallery/gallery_07.jpg';
import galleryImg07Thumb from '../images/gallery/gallery_07-thumb.jpg';
import galleryImg08 from '../images/gallery/gallery_08.jpg';
import galleryImg08Thumb from '../images/gallery/gallery_08-thumb.jpg';
import galleryImg09 from '../images/gallery/gallery_09.jpg';
import galleryImg09Thumb from '../images/gallery/gallery_09-thumb.jpg';
import galleryImg10 from '../images/gallery/gallery_10.jpg';
import galleryImg10Thumb from '../images/gallery/gallery_10-thumb.jpg';
import galleryImg11 from '../images/gallery/gallery_11.jpg';
import galleryImg11Thumb from '../images/gallery/gallery_11-thumb.jpg';
import galleryImg12 from '../images/gallery/gallery_12.jpg';
import galleryImg12Thumb from '../images/gallery/gallery_12-thumb.jpg';
import galleryImg13 from '../images/gallery/gallery_13.jpg';
import galleryImg13Thumb from '../images/gallery/gallery_13-thumb.jpg';
import galleryImg14 from '../images/gallery/gallery_14.jpg';
import galleryImg14Thumb from '../images/gallery/gallery_14-thumb.jpg';
import galleryImg15 from '../images/gallery/gallery_15.jpg';
import galleryImg15Thumb from '../images/gallery/gallery_15-thumb.jpg';
import galleryImg16 from '../images/gallery/gallery_16.jpg';
import galleryImg16Thumb from '../images/gallery/gallery_16-thumb.jpg';

const GalleryPage = () => (
  <Layout>
    <SEO title="Home" keywords={[`gatsby`, `application`, `react`]} />
    <Helmet>
      <link href="https://fonts.googleapis.com/css?family=Titillium+Web:200,300,400,600,700,900" rel="stylesheet" type="text/css" />
    </Helmet>
    <Section id="gallery" theme="dark">
      <Gallery>
        <img src={galleryImg09} thumb={galleryImg09Thumb} alt="galleryImg09" />
        <img src={galleryImg10} thumb={galleryImg10Thumb} alt="galleryImg10" />
        <img src={galleryImg11} thumb={galleryImg11Thumb} alt="galleryImg11" />
        <img src={galleryImg12} thumb={galleryImg12Thumb} alt="galleryImg12" />
        <img src={galleryImg13} thumb={galleryImg13Thumb} alt="galleryImg13" />
        <img src={galleryImg14} thumb={galleryImg14Thumb} alt="galleryImg14" />
        <img src={galleryImg15} thumb={galleryImg15Thumb} alt="galleryImg15" />
        <img src={galleryImg16} thumb={galleryImg16Thumb} alt="galleryImg16" />
        <img src={galleryImg01} thumb={galleryImg01Thumb} alt="galleryImg01" />
        <img src={galleryImg02} thumb={galleryImg02Thumb} alt="galleryImg02" />
        <img src={galleryImg03} thumb={galleryImg03Thumb} alt="galleryImg03" />
        <img src={galleryImg04} thumb={galleryImg04Thumb} alt="galleryImg04" />
        <img src={galleryImg05} thumb={galleryImg05Thumb} alt="galleryImg05" />
        <img src={galleryImg06} thumb={galleryImg06Thumb} alt="galleryImg06" />
        <img src={galleryImg07} thumb={galleryImg07Thumb} alt="galleryImg07" />
        <img src={galleryImg08} thumb={galleryImg08Thumb} alt="galleryImg08" />
      </Gallery>
    </Section>
    <ContactSection />
  </Layout>
);

export default GalleryPage;
